export const CRM_INSTITUTION_FORM_MODULE_ID = 'crm-institution-form-module';

export const LOAD_CRM_INSTITUTION_FORM_MODULE = () =>
  import('@capital-access/crm/institution-form').then(m => m.CrmInstitutionFormModule);
